import { FlaskConical } from 'lucide-react';
import type { CustomerRef } from '@portal-contract';
import { Alert, AlertDescription, AlertTitle } from '@/lib/macondo';
import { useI18n } from '@/i18n/I18nProvider';

/** True for the verification test account (docs/PORTAL-PLAN.md 8.1): the API sets `test: true`, real customers never carry it. */
export const isTestCustomer = (c: Pick<CustomerRef, 'test'> | undefined): boolean => c?.test === true;

/**
 * "TEST ACCOUNT" notice on every authenticated screen of the verification account, so nobody mistakes
 * its sample data for a customer's. A polite status (not an alert: it is not an error) that stays
 * visible when printing.
 */
export function TestAccountBanner({ className }: { className?: string | undefined }) {
  const { t } = useI18n();
  return (
    <Alert tone="warning" role="status" data-testid="test-account-banner" className={className}>
      <div className="flex items-start gap-300">
        <FlaskConical size={20} aria-hidden="true" className="mt-050 shrink-0" />
        <div className="flex flex-col gap-100">
          <AlertTitle>{t('testAccount.title')}</AlertTitle>
          <AlertDescription>{t('testAccount.body')}</AlertDescription>
        </div>
      </div>
    </Alert>
  );
}
